<script setup>
import BreezeButton from '@/Components/Button.vue';
import Layout from '@/Layouts/Layout.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';
import { __ } from '@/app';
import LayoutNew from '@/Layouts/LayoutNew.vue';
import FormHeader from '@/Components/FormHeader.vue';

const form = useForm({
    password: '',
});

const submit = () => {
    form.post(route('password.confirm'), {
        onFinish: () => form.reset(),
    })
};
</script>

<template>
    <LayoutNew>
        <div style="max-width: 350px; width: 100%;">            
            <FormHeader v-bind:title="__('Potwierdź hasło')"/>
            
            <p class="mb-2 alert alert-secondary" v-text="__('Potwierdź swoje hasło przed kontynuowaniem.')"/>

            <BreezeValidationErrors class="mb-2 alert alert-danger" />
            
            <form @submit.prevent="submit">
                <div class="mb-2">
                    <label for="password" class="form-label" v-text="__('Hasło')"/>
                    <BreezeInput v-bind:placeholder="__('Wprowadź swoje hasło')" id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
                    <div class="error" id="passwordError"></div>
                </div>
                <BreezeButton :class="{ 'opacity-25': form.processing, 'btn': true, 'btn-primary': true, 'w-100': true }" :disabled="form.processing" v-text="__( 'Wyślij link resetujący pocztą' )"/>
            </form>
        </div>
    </LayoutNew>
</template>
